import React from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import exportFromJSON from 'export-from-json';
import Theme from "highcharts/themes/grid-light";
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts)
Theme(Highcharts)

const LineChart:  any = (props:any) => {
    // console.log(props.allData);
    let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
	buttons?.push("label");
    const {allData, exportExcel, labels, title, idChart, activeButton, colores} = props;
    const options = {
		chart:{
			backgroundColor: '#f0f0f0',
			colorCount: 15,
		},

		title: {
			text: title
		},
		subtitle:{
			text:'Indicador de 0 a 100. 50 es el punto medio. Bajo 50 puntos es escenario económico pesimista y sobre 50 escenario económico optimista.'
		},
	
	
		yAxis: {
			title: "enabled"
			, reversed: false,
			labels:{
				format: '{value}'
			}
		},

		
	
		xAxis: {
			categories : labels,
		},

		tooltip: {
			shared: true,
			useHTML: true,
			headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
			pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
				'<td style="text-align: right"><b>{point.y}</b></td></tr>',
			footerFormat: '</table>',
			valueDecimals: 0
		},
	
	
		plotOptions: {
			series: {
				dataLabels: {
				align: 'right',
				enabled: true,
				inside: false
				},
				grouping: true
			}
		},
		
	
		series: allData,
		// colors: ['#00A3E0', '#8031A7', '#B5BD00', '#ed8b00', '#09699c', '#ffc000', '#E0004D',
		// 		 '#00C389', '#707372', '#bfbfbf'],
		colors: colores,
		legend: {
			enabled: true
		},
	
		responsive: {  
			rules: [{  
			  condition: {  
				maxWidth: 1000
			  },  
			  chartOptions: {
                legend: {
                    align: 'right',
                    verticalAlign: 'bottom',
                    layout: 'horizontal'
                },
               
                subtitle: {
                    text: null
                },
                credits: {
                    enabled: false
                }
            }
			}]  
		  },
		  
		  lang: {
			downloadCSV: 'Descargar CSV',
			downloadJPEG: "Descargar JPEG",
			downloadPDF: "Descargar PDF",
			downloadPNG: "Descargar PNG",      
			downloadSVG: "Descargar SVG",
			downloadXLS: "Descargar XLS",
			exitFullscreen: "Salir de pantalla completa",
			viewFullscreen: "Ver Pantalla Completa",
			printChart: "Imprimir Gráfico"
		  },

		  exporting: {
			enabled: activeButton, 
			menuItemDefinitions: {
				// Custom definition
				label: {
					onclick: (event:any) => {
						console.log('clic boton custom');
						exportExcel({titulo: title, id: idChart});
					},
					text: 'Descargar XLSX'
				}
			},
			
			buttons: {
				contextButton: {
					menuItems: [
						"viewFullscreen",
						"printChart",
						"separator",
						"downloadPNG",
						"downloadJPEG",
						"downloadPDF",
						"downloadSVG",
						"separator",
						"label"
					]
				}
			}
		},
		credits: {
			enabled: false
		}
	}

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </>
    )
}

export default LineChart;